import {DateValueObject} from './DateValueObject.js'

export default class DateValueObjectsFactory {
  /**
   * @method
   * @params {Object} deps
   * @property {Date} deps.date
   * @return {DateValueObject}
   */
  static dateValueObject = ({date}) => {
    DateValueObject.validate({date})
    return new DateValueObject({date})
  }
}
